import type { SVGProps } from "react";
const SvgJusticeScale01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 5v17m0 0H9m3 0h3M21 13l-2.5-5-2.5 5M8 13 5.5 8 3 13"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4 8h1.048c1.264 0 2.49-.529 3.476-1.5 2.032-2 4.92-2 6.952 0 .986.971 2.212 1.5 3.476 1.5H20"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M18.5 17c1.355 0 2.534-.834 3.147-2.065.331-.665.496-.997.195-1.466C21.54 13 21.04 13 20.04 13h-3.082c-.999 0-1.499 0-1.8.469-.302.469-.137.801.194 1.466C15.966 16.166 17.145 17 18.5 17ZM5.5 17c1.355 0 2.534-.834 3.147-2.065.331-.665.496-.997.195-1.466C8.54 13 8.04 13 7.04 13H3.959c-.999 0-1.499 0-1.8.469-.302.469-.137.801.194 1.466C2.966 16.166 4.145 17 5.5 17ZM13.5 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
    />
  </svg>
);
export default SvgJusticeScale01;
